import {
	ratingCardContainerSX,
	ratingSX,
	ratingsAndReviewsSX,
	starIconSX,
} from '@/components/blocks/RatingCard/styles/ratingCard';
import { RatingType } from '@/data/types/Product';
import { mergeSx } from '@/utils/mergeSx';
import StarIcon from '@mui/icons-material/Star';
import { Box, Rating, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';

type RatingCardProps = {
	ratings?: RatingType;
	sx?: SxProps<Theme>;
};

export const RatingCard: FC<RatingCardProps> = ({ ratings, sx }) => {
	const reviews = ratings?.reviews ?? 0;
	const rating = ratings?.rating ?? 0;

	return (
		<Box
			display="flex"
			flexWrap="wrap"
			gap={0.5}
			alignItems="center"
			sx={sx ? mergeSx(ratingCardContainerSX, sx) : ratingCardContainerSX}
		>
			<Rating
				name="read-only"
				value={Math.round(rating)}
				readOnly
				size="small"
				sx={ratingSX}
				emptyIcon={<StarIcon sx={starIconSX} fontSize="inherit" />}
			/>

			<Typography noWrap sx={ratingsAndReviewsSX}>{`${rating} (${reviews})`}</Typography>
		</Box>
	);
};
